// extracted by mini-css-extract-plugin
module.exports = {"headline":"returns_headline__D2K8g","content":"returns_content__Q6LPI","container":"returns_container__pl7_f"};